import { firebaseApp } from '../../../services/firebase'

export const activeProjectId = (): string => {
  try {
    return (firebaseApp.options as { projectId?: string }).projectId ?? 'unknown-project'
  } catch {
    return 'unknown-project'
  }
}

export type EnvPillConfig = {
  label: string
  className: string
  tooltip: string
}

export const getEnvPillConfig = (projectId: string): EnvPillConfig => {
  if (projectId === 'timelining-sit') {
    return {
      label: 'SIT',
      className: 'ownerEnvBadge--sit',
      tooltip: `SIT · ${projectId}`,
    }
  }
  if (projectId === 'timelining-app') {
    return {
      label: 'DEV',
      className: 'ownerEnvBadge--dev',
      tooltip: `DEV · ${projectId}`,
    }
  }
  if (projectId === 'timelining-prod') {
    return {
      label: 'PROD',
      className: 'ownerEnvBadge--prod',
      tooltip: `PROD · ${projectId}`,
    }
  }
  return {
    label: projectId,
    className: 'ownerEnvBadge--other',
    tooltip: `ENV · ${projectId}`,
  }
}
